export type AuthTokenGetter = () => string | null | Promise<string | null>;
export type UnauthorizedHandler = () => void;

let getter: AuthTokenGetter | null = null;
let on401: UnauthorizedHandler | null = null;

export const setAuthTokenGetter = (g: AuthTokenGetter): void => {
  getter = g;
};

export const setUnauthorizedHandler = (h: UnauthorizedHandler): void => {
  on401 = h;
};

export const getAuthToken = async (): Promise<string | null> => {
  if (!getter) return null;
  return await getter();
};

export const fireUnauthorized = (): void => {
  on401?.();
};

export const hasAuthGetter = (): boolean => getter !== null;
